import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const jiraBusinessTimelineEmbedRoute: InvariantJiraRoute = {
	name: 'classic-business-timeline-embed',
	path: '/jira/core/projects/:projectKey/timeline/embed',
	exact: true,
};
